<template>
    <div>
        <div v-if="caption != undefined">{{ caption }}</div>
        <div class="row mt-4">
            <actual-groups-of-one-type class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                                       v-for="courseType in selectedCourseTypes"
                                       :show-next-groups="showNextGroups"
                                       :old-groups-count="oldGroupsCount"
                                       :course-type="courseType"
                                       :key="courseType.value"
                                       @select-course-group="selectCourseGroup"></actual-groups-of-one-type>
        </div>
    </div>
</template>
<script>

import ActualGroupsOfOneTypeComponent from "./ActualGroupsOfOneType.vue";

const ActualGroupsComponent = {
    props: {
        caption: {
            type: String,
            required: false
        },
        oldGroupsCount: {
            type: Number,
            default: 3
        },
        showNextGroups: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            selectedCourseTypes: [
                window.AcademIt.CourseType.ProgrammingBegin,
                window.AcademIt.CourseType.Test,
                window.AcademIt.CourseType.ProgrammingOop,
                window.AcademIt.CourseType.ProgrammingOopPython,
                window.AcademIt.CourseType.TechnicalOutlook,
                window.AcademIt.CourseType.AutoTest,                
                window.AcademIt.CourseType.ClientWeb,
                window.AcademIt.CourseType.JavaWeb,
                window.AcademIt.CourseType.CSharpWeb,
                window.AcademIt.CourseType.AutoTestBasics,
                window.AcademIt.CourseType.Docker,
                window.AcademIt.CourseType.IndividualLessons
            ]
        };
    },

    components: {
        "actual-groups-of-one-type": ActualGroupsOfOneTypeComponent
    },

    methods: {
        selectCourseGroup(courseGroup) {
            this.$emit("select-course-group", courseGroup);
        }
    }
};

export default ActualGroupsComponent;
</script>
